<template>
  <div class="root">
    <div class="content">
      <img class="mainImg" :src="img_src" />
      <div class="bottom" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, defineProps } from 'vue';
import TemplateRequest from '../../data/TemplateRequest';

const props = defineProps<{
  view_key: string;
}>();

const img_src = ref('');

onMounted(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var cardData: any = TemplateRequest.getViewDataByKey(props.view_key);
  img_src.value = cardData.img_src;
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.root {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
}

.content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  height: auto;
}

.mainImg {
  width: 100%;
  height: auto;
}

.bottom {
  position: absolute;
  bottom: -1px;
  margin-top: auto;
  width: 100%;
  height: 50px;
  background: linear-gradient(180deg, rgb(0 0 0 / 0%) 0%, #ffffff 100%);
}
</style>
